import { gql } from "@apollo/client";

export const AssetIoTConnectionStatus = gql`
  query AssetIoTConnectionStatus($id: ID!) {
    assetLocation(id: $id) {
      id
      iotConnection {
        id
        connectionStatus
      }
    }
  }
`;

/**
 * IoT-hub connectivity in isolation. When the backend's hub lookup fails for a
 * device it silently nulls the WHOLE iotConnection (no errors entry), so this
 * field must never share a selection with connectionStatus/id consumers — and
 * every consumer must use fetchPolicy "no-cache" so a nulled iotConnection can't
 * clobber the cached connection of the other queries.
 */
export const AssetIoTHubStatus = gql`
  query AssetIoTHubStatus($id: ID!) {
    assetLocation(id: $id) {
      id
      iotConnection {
        id
        iotHubConnectivityStatus
      }
    }
  }
`;

/**
 * Same backend behavior as AssetIoTHubStatus: a failed network lookup silently
 * nulls the WHOLE iotConnection (verified against assetLocation 21489,
 * 2026-10-09), so every consumer must use fetchPolicy "no-cache".
 */
export const AssetNetworkInfo = gql`
  query AssetNetworkInfo($id: ID!) {
    assetLocation(id: $id) {
      id
      iotConnection {
        id
        networkInformation {
          networkProvider
          currentStandard
          signalStrength
        }
      }
    }
  }
`;
